import {Cesium3DTileFeature, Color} from "cesium";
import {BaseStylist} from "./BaseStylist";

export class FeatureStylist extends BaseStylist<Cesium3DTileFeature> {

  extractValue(feature: Cesium3DTileFeature): number | undefined {
    return this.selectedAttributeName ? feature.getProperty(this.selectedAttributeName) : undefined ;
  }
}